// One handler covers React links and links rendered from article Markdown.
// GA4 enhanced outbound measurement is off to avoid duplicate click events.
function trackOutboundClick(event, location, gtag) {
  if (event.defaultPrevented || typeof gtag !== "function") return;
  const target = event.target?.closest ? event.target : event.target?.parentElement;
  const link = target?.closest("a[href]");
  if (!link) return;
  let url;
  try {
    url = new URL(link.href, location.href);
  } catch {
    return;
  }
  if (!/^https?:$/.test(url.protocol) || url.hostname === location.hostname) return;
  gtag("event", "click", {
    event_category: "outbound",
    event_label: link.getAttribute("href"),
    link_url: url.href,
    link_domain: url.hostname,
    link_id: link.id || "",
    link_classes: link.className || "",
    outbound: true,
    transport_type: "beacon",
  });
}

module.exports = { trackOutboundClick };
